import { loadScript, removeScript } from '../../helpers';
import { LoginWithFacebookHandler } from './facebook';
const ERRORS = {
    FAIL_TO_LOAD: '(!)GoogleAuthProvider: Failed to initialize GoogleAuth',
};
export class LoginWithGoogleHandler {
    static SDK_URL = 'https://apis.google.com/js/api.js';
    static SDK_ID = 'google-sdk';
    configs;
    constructor(clientId, ssoServerUrl) {
        this.configs = { clientId, ssoServerUrl };
    }
    async signIn(options) {
        try {
            const isConnected = await this.loadSDK();
            if (!isConnected) {
                return [undefined, ERRORS.FAIL_TO_LOAD];
            }
            const GoogleAuth = window.gapi?.auth2?.getAuthInstance?.();
            if (!GoogleAuth)
                throw new Error('Google SDK load fail!');
            const { uxMode, redirectUrl, state } = options || {};
            const googleSigninOpts = {
                prompt: 'select_account',
                ux_mode: uxMode,
                redirect_uri: redirectUrl,
            };
            if (state) {
                //@ts-ignore
                googleSigninOpts.state = JSON.stringify(state);
            }
            const googleSignInResponse = await GoogleAuth.signIn(googleSigninOpts);
            const token = googleSignInResponse.getAuthResponse(true).id_token;
            return [token];
        }
        catch (error) {
            console.debug('(!) Signin with google:', error instanceof Error ? error.message : error);
            return [, error instanceof Error ? error.message : 'Login failed'];
        }
    }
    async getCurrentSessionToken() {
        const GoogleAuth = window.gapi?.auth2?.getAuthInstance?.();
        if (!GoogleAuth)
            return;
        return GoogleAuth.currentUser.get().getAuthResponse(true).id_token;
    }
    signOut() {
        const GoogleAuth = window.gapi?.auth2?.getAuthInstance?.();
        if (!GoogleAuth)
            return;
        const isSignedIn = GoogleAuth.isSignedIn.get();
        if (isSignedIn) {
            GoogleAuth.signOut();
        }
    }
    loadSDK() {
        return new Promise(resolve => {
            if (window.gapi) {
                return resolve(true);
            }
            loadScript(LoginWithGoogleHandler.SDK_URL, LoginWithFacebookHandler.SDK_ID, {
                onLoad: () => {
                    window.gapi.load('auth2', () => {
                        const GoogleAuth = window.gapi?.auth2?.getAuthInstance?.();
                        if (!GoogleAuth) {
                            window.gapi.auth2
                                .init({
                                client_id: this.configs.clientId,
                                plugin_name: 'ares',
                            })
                                .then(() => resolve(true), (error) => {
                                console.debug(ERRORS.FAIL_TO_LOAD, error);
                                resolve(false);
                            });
                        }
                        else {
                            resolve(true);
                        }
                    });
                },
                onError: () => {
                    resolve(false);
                },
            });
        });
    }
    removeSDK() {
        removeScript(LoginWithGoogleHandler.SDK_ID);
    }
}
//# sourceMappingURL=google.js.map